import React, { useState } from 'react';
import styled from 'styled-components';
import { SystemAlertData } from '../../../shared/dto/EntityRepository';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { useAdminSystemAlert } from '../../share/hook/useAdminSystemAlert';
import { isoInstantToLocalDateInput, isoInstantToLocalInput } from '../../../shared/util/timeInvertor/time';

interface SystemAlertInfoProps {
  data: SystemAlertData;
  isSelected: boolean;
  handleClick: () => void;
}

const SystemAlertInfo: React.FC<SystemAlertInfoProps> = ({
  data,
  isSelected,
  handleClick
}) => {
  const { activeSystemAlert } = useAdminSystemAlert();
  const [hovered, setHovered] = useState(false);

  return (
    <SystemAlertInfoComp
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ContentWrapper>
        <TitleBlock $isHover={hovered} $isActive={isSelected}>
          <TitleText>{data.type}</TitleText>
        </TitleBlock>
        <AdminBlockWithVisible
          width={"1.5"}
          value={data.message}
          isHover={hovered}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width={"1"}
          value={isoInstantToLocalDateInput(data.createdAt)}
          isHover={hovered}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width={"1.5"}
          value={isoInstantToLocalInput(data.scheduledStartAt)}
          isHover={hovered}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width={"1.5"}
          value={isoInstantToLocalInput(data.scheduledEndAt)}
          isHover={hovered}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width={"1"}
          value={data.endedAt || "Not Ended Yet"}
          isHover={hovered}
          isActive={isSelected}
        />
        {activeSystemAlert && <SpaceBlock />}
      </ContentWrapper>
    </SystemAlertInfoComp>
  );
};


const SystemAlertInfoComp = styled.article`
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  min-height: 40px;
  cursor: pointer;
  
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const TitleBlock = styled.div<{ $isHover: boolean; $isActive: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: 10px;
  text-decoration: ${({ $isActive }) => ($isActive ? 'underline' : 'none')};
  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive ? theme.colors.color_Gray_06 : $isHover ? theme.colors.color_Gray_07 : 'transparent'};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
  cursor: pointer;
`;

const TitleText = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export default SystemAlertInfo;
